import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#FFB000" />
    <path d="M44 20.5A16 16 0 1 0 44 43.5" fill="none" stroke="#0D0D0B" strokeWidth="8" strokeLinecap="round" />
    <path d="M38 32h16m-6-6 6 6-6 6" fill="none" stroke="#0D0D0B" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Logo = ({ testid, light = true }) => (
  <Link to="/" data-testid={testid} className="flex items-center gap-2.5 group" aria-label="Cazares Junk Removal home">
    <LogoMark className="h-9 w-9 transition-transform duration-500 group-hover:-rotate-12" />
    <span className={`leading-none ${light ? "text-[#F2EEE6]" : "text-[#0D0D0B]"}`}>
      <span className="font-display block text-2xl tracking-wide">CAZARES</span>
      <span className="block text-[10px] font-bold tracking-[0.28em] uppercase opacity-80">Junk Removal</span>
    </span>
  </Link>
);
